module.exports = __webpack_public_path__ + "img/1509316236.4da91feb.jpg";